import axios from 'axios'
import { DateFactory } from 'rhg-vue-common'
import { getQueryParams, dayOfWeekToDate as DayOfWeekToDate } from '@/infrastructure/Utils'
import AvailabilityService from '@/services/AvailabilityService'
import HotelStayDatesFactory from '@/factory/HotelStayDatesFactory'
import RoomService from '@/services/RoomService'
import BookingService from '@/services/BookingService'
import { cashFirst, pointsFirst } from '@/domain/Sorters'
import ExchangeRatesService from '@/services/ExchangeRatesService'
import NearbyHotelsService from '@/services/NearbyHotelsService'
import { location } from '@/infrastructure/Configuration'
import SocialMediaService from '@/services/SocialMediaService'
import { linksToShare } from '@/domain/SocialMedia'
import HotelService from '../../services/HotelService'
import DaysOfWeek from '@/domain/DaysOfWeek'
import NewRdHotelService from '../services/NewRdHotelService'
import TripAdvisorService from '../services/TripAdvisorService'
import NewRdBookingService from '@/services/NewRdBookingService'
import NewRdTrackingService from '../services/NewRdTrackingService'
import MembersBenefitService from '../services/MembersBenefits'
import QubitService from '@/services/QubitService'
import ExperienceAccumulatedPrice from '../../domain/ExperienceAccumulatedPrice'

axios.defaults.headers.common['accept-language'] = location
axios.defaults.timeout = 30000

const getExperienceAccourdingEnvirontment = () => {
  let experience = new ExperienceAccumulatedPrice({})
  if (process.env.NODE_ENV === 'development') {
    experience = new ExperienceAccumulatedPrice({
      trackingId: 'radisson_hotels_staging',
      experienceIds: 224153,
      qubitService
    })
  } else {
    experience = new ExperienceAccumulatedPrice({
      trackingId: global.ConfigDynamic.valueOf(global.configDynamicKey?.QUBIT_EXPERIENCE_ACC_PRICES_TRACKING_ID),
      experienceIds: global.ConfigDynamic.valueOf(global.configDynamicKey?.QUBIT_EXPERIENCE_ACC_PRICES_EXPERIENCE_IDS),
      qubitService
    })
  }
  return experience
}

export const dayOfWeekToDate = DayOfWeekToDate({
  dateFactory: DateFactory,
  types: DaysOfWeek
})

export const hotelStayDatesFactory = new HotelStayDatesFactory(dayOfWeekToDate, DateFactory)
export const availabilityService = new AvailabilityService(axios, hotelStayDatesFactory, DateFactory)
export const roomService = new RoomService(axios)
export const labelsService = global.labelsService || {}
export const bookingService = new BookingService(axios, global.device)
export const exchangeRatesService = new ExchangeRatesService(axios)
export const nearbyHotelsService = new NearbyHotelsService(axios)

const { paymentType } = getQueryParams(window.location._search || window.location.search)

export const cheapestToMostExpensiveRates = (paymentType && paymentType === 'onlyPointsAndCashPoints') ? pointsFirst : cashFirst

export const socialMediaService = new SocialMediaService({
  linksToShare
})

export const hotelService = new HotelService(axios)

export const newRdHotelService = new NewRdHotelService(axios)
export const newRdBookingService = new NewRdBookingService(axios)
export const newRdTrackingService = new NewRdTrackingService()
export const tripAdvisorService = new TripAdvisorService(axios)
export const membersBenefitService = new MembersBenefitService(axios)
export const qubitService = new QubitService(axios)
export const experienceAccumulatedPrice = getExperienceAccourdingEnvirontment()
